import { render, staticRenderFns } from "./DvSkeleton.vue?vue&type=template&id=d65b5f10&scoped=true&"
import script from "./DvSkeleton.vue?vue&type=script&lang=ts&"
export * from "./DvSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./DvSkeleton.vue?vue&type=style&index=0&id=d65b5f10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b5f10",
  null
  
)

export default component.exports